<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="padding-top:250px;">“Let us leave the confusion and all disillusion behind.”</p>
<p style="text-align: right;">– Franco Migliacci and Domenic Molugno</p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?4dd7111d